/* HY Size chart: opens <dialog id="…"> from any [data-hy-dialog="…"] or a[href="#…"] trigger. */
(() => {
  if (window.hySizeChart) return;
  window.hySizeChart = true;
  const find = (el) => {
    const t = el.closest('[data-hy-dialog], a[href^="#"]');
    if (!t) return null;
    const id = t.dataset.hyDialog || t.getAttribute('href').slice(1);
    const d = id && document.getElementById(id);
    return d && d.tagName === 'DIALOG' ? d : null;
  };
  document.addEventListener('click', (e) => {
    const d = find(e.target);
    if (d) { e.preventDefault(); d.showModal(); return; }
    const open = e.target.closest('dialog.hy-sc__dialog[open]');
    if (!open) return;
    // Close on the close button, or on a click outside the panel (backdrop).
    if (e.target.closest('[data-hy-dialog-close]') || !e.target.closest('.hy-sc__panel')) open.close();
  });
})();
